import type { ko } from './ko';

export const en: typeof ko = {
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
  },
  tabs: {
    home: 'Home',
    myLeaves: 'My Leave',
    settings: 'Settings',
  },
  settings: {
    title: 'Settings',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    language: 'Language',
    account: 'Account',
    logout: 'Log out',
  },
  push: {
    open: 'Open',
  },
};
